export default __webpack_public_path__ + "static/media/12WBTLifestyleLogoColor.efd5cc9d.png";